import { ProgressiveModalDirectionKeys } from './progressive-modal.types';

export const progressiveModalTransition = {
  x: { type: 'keyframes', stiffness: 500, damping: 30, duration: 0.2 },
  opacity: { duration: 0.2 },
  zIndex: { duration: 0 },
};

export const progressiveModalAnimationVariants = {
  enter: (direction: Omit<ProgressiveModalDirectionKeys, 'center'>) => ({
    x: direction === ProgressiveModalDirectionKeys.left ? 320 : -360,
    zIndex: 55,
    opacity: 0,
  }),
  center: {
    zIndex: 300,
    x: 0,
    opacity: 1,
  },
  exit: (direction: Omit<ProgressiveModalDirectionKeys, 'center'>) => ({
    zIndex: 0,
    x: direction === ProgressiveModalDirectionKeys.left ? -360 : 320,
    opacity: 0,
  }),
};
